import { useSearchParams } from "react-router-dom";
import { RetailList } from "./Retail";
import { RoiList } from "./Roi";
import { PricingList } from "./Pricing";
import { FraudList } from "./Fraud";

const AISTUDIO_TABS = [
  {
    tabIndex: 0,
    tabId: "retail",
    tabName: "AI Studio in Retail",
  },
  {
    tabIndex: 1,
    tabId: "roi",
    tabName: "ROI & Governance",
  },
  {
    tabIndex: 2,
    tabId: "pricing",
    tabName: "Pricing & Demand Simulator",
  },
  {
    tabIndex: 3,
    tabId: "fraud",
    tabName: "Fraud Detection Engine",
  },
];

const AIStudioFramework = (): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams({ tabIndex: "0" });

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set("tabIndexOne", JSON.stringify(tabId));
      return params;
    });
  };
  const tabIndex = searchParams.get("tabIndexOne");
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <>
      <div className="podcasts-tab">
        {AISTUDIO_TABS.map((tab) => {
          const { tabIndex, tabId, tabName } = tab;

          return (
            <div
              key={tabId}
              className={`item ${tabIndex === parsedTabIndex ? "active" : ""}`}
              onClick={() => handleTabChange(tabIndex)}
            >
              {tabName}
            </div>
          );
        })}
      </div>
      <>
        {parsedTabIndex === 0 && <RetailList />}
        {parsedTabIndex === 1 && <RoiList />}
        {parsedTabIndex === 2 && <PricingList />}
        {parsedTabIndex === 3 && <FraudList />}
      </>
    </>
  );
};

export default AIStudioFramework;
